export enum CalibrationActionRequire {
    ATODueDate = 'ATO DUE DATE NEEDED',
    ATONumber = 'ATO NUMBER NEEDED',
    RepairWorkOrder = 'REPAIR WO NEEDED'
}
